import LogoDefault from 'components/logos/logo-default';
import LogoNav from 'components/logos/logo-nav';

export const Logos = {
  'default': LogoDefault,
  'nav': LogoNav
}



// WEBPACK FOOTER //
// ./src/client/helpers/enums/logos.js